import {
  GraphQLEnumType,
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'

/* NOTE: this query exists in react-query as useAgentFeatures: src/components/agent-features/use-agent-features.ts */

interface AgentFeature {
  readonly name: string
  readonly languages: AgentLanguageEnum[]
}

interface AgentFeatures {
  readonly features: AgentFeature[]
}

export enum AgentLanguageEnum {
  JAVA = 'JAVA',
  DOTNET = 'DOTNET',
  DOTNET_CORE = 'DOTNET_CORE',
  NODE = 'NODE',
  RUBY = 'RUBY',
  PYTHON = 'PYTHON',
  PHP = 'PHP',
  PROXY = 'PROXY',
  GO = 'GO'
}

const AgentLanguageType = new GraphQLEnumType({
  name: 'AgentLanguage',
  description: 'Agent language',
  values: {
    JAVA: {
      value: AgentLanguageEnum.JAVA
    },
    DOTNET: {
      value: AgentLanguageEnum.DOTNET
    },
    DOTNET_CORE: {
      value: AgentLanguageEnum.DOTNET_CORE
    },
    NODE: {
      value: AgentLanguageEnum.NODE
    },
    RUBY: {
      value: AgentLanguageEnum.RUBY
    },
    PYTHON: {
      value: AgentLanguageEnum.PYTHON
    },
    PHP: {
      value: AgentLanguageEnum.PHP
    },
    PROXY: {
      value: AgentLanguageEnum.PROXY
    },
    GO: {
      value: AgentLanguageEnum.GO
    }
  }
})

const AgentFeatureType = new GraphQLObjectType({
  name: 'AgentFeature',
  description: 'Configuration of agents which this feature is enabled for',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString)
    },
    languages: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(AgentLanguageType))
      )
    }
  })
})

const AgentFeaturesType = new GraphQLObjectType({
  name: 'AgentFeatures',
  fields: () => ({
    features: {
      description: 'How many assess licenses have already been consumed',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(AgentFeatureType))
      )
    }
  })
})

export type AgentFeaturesQueryResult = Partial<AgentFeatures>

export const agentFeatures: ContrastGraphQLFieldConfig<
  any,
  Context,
  any,
  AgentFeaturesQueryResult
> = {
  description: 'Get features enabled for agents',
  type: new GraphQLNonNull(AgentFeaturesType),
  args: {},
  resolve: (_source, _args, context) => {
    if (
      window.location.href.includes('signin') ||
      window.location.href.includes('logout')
    ) {
      return Promise.resolve({ features: [] }) // Avoid call /agent/feature when there is no session
    }

    return context.connector.get('/agent/feature')
  }
}
